/* eslint-disable */
import {
  SET_LAYER_VISIBILITY,
  SET_GROUP_VISIBILITY,
  SET_CURRENT_MAP_COMPOSITION,
  SET_CURRENT_MINIMAP_COMPOSITION,
  SET_LAYERS_AREA,
} from '../constants';

const setCurrentMapComposition = composition => dispatch => {
  dispatch({ type: SET_CURRENT_MAP_COMPOSITION, payload: composition });
};

const setCurrentMiniMapComposition = composition => dispatch => {
  dispatch({ type: SET_CURRENT_MINIMAP_COMPOSITION, payload: composition });
};

const setMapLayerVisibility = layer => dispatch => dispatch({ type: SET_LAYER_VISIBILITY, payload: layer });
const setMapGroupVisibility = group => dispatch => dispatch({ type: SET_GROUP_VISIBILITY, payload: group });

const setLayersArea = (index)=> ({type: SET_LAYERS_AREA, payload: index});

export { setCurrentMapComposition, setCurrentMiniMapComposition, setMapLayerVisibility, setMapGroupVisibility, setLayersArea };



// WEBPACK FOOTER //
// src/actions/layers.js